import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Modal } from "react-bootstrap";
import {
  get_Notification_rule,
  get_Single_Notification_rule,
} from "../../../store/actions/CommanAction";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdate, getPostData,getData } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { IoNotifications } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import Loader from "../Loader/Loader";

import { format } from "date-fns";

const NotificationRuleList = () => {
  const dispatch = useDispatch();
  const Notificationdata = useSelector(
    (state) => state.feedBackReducer.GetNotificationrule
  );
 
  const SingleNotificationdata = useSelector(
    (state) => state.feedBackReducer.GetSingleNotificationRule
  );

  const customerID = Number(sessionStorage.getItem("ID"));
  const [editValue, setEditValue] = useState([]);
  const [postModel, setPostModel] = useState(false);
  const [editModel, setEditModel] = useState(false);
  const [id, setId] = useState("");
   const [previewImage,setPreviewImage]=useState("")
    const [logoImage, setLogoImage] = useState(null);

  const [ArrObj, setArrayObj] = useState([]);
  const [label, setLabel] = useState();
  const [querryText, setQuerryText] = useState("");
  const [autoManual, setautoManual] = useState(false);
  const [name, setname] = useState("");
  const [loading, setLoading] = useState(false);
  const [rulename, setRulename] = useState("");

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [isTopAstrologerSend, setIsTopAstrologerSend] = useState(false);
  const [astrologers, setAstrologers] = useState([]);
  const [selectedAstrologer, setSelectedAstrologer] = useState(null);
  const [type, setType] = useState("push");
  const [audience, setAudience] = useState("All");
  const [scheduled, setScheduled] = useState(null);
  const [date, setDate] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [notificationId, setNotificationId] = useState("");
  

  const [convertedJpg1, setConvertedJpg1] = useState(null);
  const [convertedPng1, setConvertedPng1] = useState(null);

  const [convertedJpg2, setConvertedJpg2] = useState(null);
  const [convertedPng2, setConvertedPng2] = useState(null);


  const [beforeSendDays, setBeforeSendDays] = useState(false);
  const [columnType, setColumnType] = useState("");
  const [drpdatas, setDrpdatas] = useState([])
  const [selectedID, setSelectedID] = useState("");
  const [data, setdata] = useState([])
 
  const [filters, setFilters] = useState([
    { field: "zodiac", operator: "=", value: "", logic: "" },
  ]);

  const reset = () => {
    setTitle("");
    setMessage("");
    setType("");
    setAudience(" ");
    setScheduled();
    setBeforeSendDays(false);
    setColumnType("");
    setFilters([]);

    setId("")
    setDate("")
    setSelectedID("")
    setConvertedJpg2(null)
    setConvertedJpg1(null)
    setPreviewImage("")
    setLogoImage(null)
    // setIsTopAstrologerSend(false)
  };
  const handleFilterChange = (index, key, value) => {
    const updated = [...filters];
    updated[index][key] = value;
    setFilters(updated);
  };

  const addFilter = () => {
    setFilters([
      ...filters,
      { field: "", operator: "=", value: "", logic: "" },
    ]);
  };


  const deleteFilter = (index) => {
    const updated = filters.filter((_, i) => i !== index);
    setFilters(updated);
  };
  const drpdata = async () => {
    const res = await AddUpdate("NotificationSegments/NotificationRulesDrp")
    const data = res?.data?.data || '{}';

    const parse = JSON.parse(data)
    const actualdata = parse?.Table;
    setDrpdatas(actualdata)



  }

  const fetchAstrologers = async () => {
    try {
      const payload = { IsActive: 1 };
      const res = await getData('Astrologer/GetDropDwonAstrologers');
     
      const list = Array.isArray(res) ? res : [];
      setAstrologers(list);
    } catch (err) {
      console.error('Failed to fetch astrologers:', err);
      setAstrologers([]);
    }
  }

  useEffect(() => {
    drpdata();
  }, [])
  const handleSubmit = async () => {
    if (!title.trim()) {
      swal("Missing Title", "Please enter a notification title.", "warning");
      return;
    }

    if (!message.trim()) {
      swal(
        "Missing Message",
        "Please enter a message for the notification.",
        "warning"
      );
      return;
    }

    if (!audience) {
      swal("Missing Audience", "Please select an audience type.", "warning");
      return;
    }



    try {
      const formData = {
        Title: title,
        Message: message,
        Audience: audience,
        BeforeSendDays: beforeSendDays,
        Scheduled: scheduled,
        ScheduledDateTime: date,
        ColumnType: columnType,
        FieldName: filters?.[0]?.field || "",
        FieldValue: filters?.[0]?.value || "",
        Operator: filters?.[0]?.operator || "",
        LogicType: filters?.[0]?.logic || "",
        SortOrder: 0,
        NotificationId: selectedID
      };

      const formPayload = new FormData();

      if (convertedJpg1) {
       
        formPayload?.append("UploadImage", convertedJpg1, "main.jpg");
      }

      if (convertedJpg2) {
        
        formPayload?.append("LogoImage", convertedJpg2, "logo.jpg");
      }
    
     
      formPayload.append("Data", JSON.stringify(formData));

      await AddUpdate("NotificationSegments/Insert_Notifications", formPayload);
      dispatch(get_Notification_rule(setLoading));


      swal("Good job!", "Successfully inserted", "success");
      setPostModel(false);
    } catch (err) {
      console.error("Error submitting notification:", err);
      swal(
        "Error",
        "Something went wrong while submitting the notification.",
        "error"
      );
    }
  };
 
const handleUpdate = async (e) => {
  e.preventDefault();

  try {
   
    const formattedDate = date
      ? format(new Date(date), "yyyy-MM-dd hh:mm a")
      : null;

    const formData = {
      NotificationId: id, 
      Title: title,
      Message: message,
      Audience: audience,
      BeforeSendDays: beforeSendDays,
      Scheduled: scheduled,
      ScheduledDateTime: formattedDate,
      ColumnType: columnType,
      FieldName: filters?.[0]?.field || "",
      FieldValue: filters?.[0]?.value || "",
      Operator: filters?.[0]?.operator || "",
      LogicType: filters?.[0]?.logic || "",
      SortOrder: 0,
      NotificationIdRef: selectedID,
    };

    const formPayload = new FormData();

    if (convertedJpg1) {
      formPayload.append("UploadImage", convertedJpg1, "main.jpg");
    }

    if (convertedJpg2) {
      formPayload.append("LogoImage", convertedJpg2, "logo.jpg");
    }

    formPayload.append("Data", JSON.stringify(formData));

   
    await AddUpdate("NotificationSegments/Update_Notification", formPayload);

    swal("Updated!", "Notification updated successfully", "success");

    setPostModel(false);
    reset(); 
    dispatch(get_Notification_rule(setLoading)); 
  } catch (err) {
    console.error("Error updating notification:", err);
    swal("Error", "Something went wrong while updating", "error");
  }
};


  const dropdown = async () => {
    try {
      const postData = { Audience: audience };
      const response = await AddUpdate(
        "NotificationSegments/GetFieldDropDown",
        postData
      );

      const parsedData = JSON.parse(response?.data?.data || '{}');

      if (Array.isArray(parsedData?.Table)) {
        setFieldOptions(parsedData.Table);
      } else {
        setFieldOptions([]);
        console.warn("Expected Table array, got:", parsedData);
      }
    } catch (err) {
      console.error("Dropdown API failed:", err);
      setFieldOptions([]);
    }
  };




  useEffect(() => {
    if (audience === "User" || audience === "Astrologer") {
      dropdown();
    }
  }, [audience]);

  useEffect(() => {
    dispatch(get_Notification_rule(setLoading));
  }, []);
  useEffect(() => {
    if (SingleNotificationdata?.length > 0) {
      setEditValue(SingleNotificationdata);
    }
  }, [SingleNotificationdata]);

  useEffect(() => {
    if (editValue && editValue.length > 0) {
      
      setRulename(editValue[0]?.NotificationName);
      setQuerryText(editValue[0]?.NotificationRule || "");

      
    }
  }, [editValue]);

  const AddObj = () => {
    const newObj = {
      label: label,
      name: label,
      type: type,
      field: label,
      operator: "equal",
      value: "", //0
    };
    setArrayObj([...ArrObj, newObj]);
  };

  const HandleDrp = (e) => {
    const val = e.target.value;

    if (e) {
     
      if (val === "ID") {
        setLabel(val);
        setType("Number");
      } else if (val === "Name") {
        setLabel(val);
        setType("String");
      } else if (val === "Title") {
        setLabel(val);
        setType("String");
      } else if (val === "Location") {
        setLabel(val);
        setType("String");
      }
    } else {
      console.log("Error");
    }
  };

  const handleRowChange = (e, row, index) => {
    const newObj = {
      label: e.target.value,
      name: e.target.value,
      field: e.target.value,
      type: e.target.value === "ID" ? "Number" : "String",
      operator: row?.operator,
      value: row?.value,
    };

    const modifiedArr = ArrObj.map((item, i) => (i === index ? newObj : item));

    setArrayObj(modifiedArr);
  };

  const handle_OperatorChange = (e, row, index) => {
    const newObj = {
      label: row?.label,
      name: row?.name,
      field: row?.field,
      type: row?.type,
      operator: e.target.value,
      value: row?.value,
    };

    const modifiedArr = ArrObj.map((item, i) => (i === index ? newObj : item));
    setArrayObj(modifiedArr);
  };

  const handleChange = (e, row, index) => {
    const newObj = {
      label: row?.label,
      name: row?.name,
      field: row?.field,
      type: row?.type,
      operator: row?.operator,
      value: e.target.value,
    };

    const modifiedArr = ArrObj.map((item, i) => (i === index ? newObj : item));
    setArrayObj(modifiedArr);
  };

  const SubmitQuerry = async (ModifiedArr) => {
    let queryTxt = "";

    ModifiedArr.forEach((item, index) => {
      const condition = `${item.field} ${getQueryValues(
        item.name,
        item.operator,
        item.value
      )}`;
      queryTxt += index === 0 ? condition : ` AND ${condition}`;
    });

    setQuerryText(queryTxt);
  };

  const handleFinalSubmit = async () => {
    if ((querryText && name) || autoManual) {
      const postdata = {
        NotificationName: rulename,
        NotificationRules: querryText,
      };

      try {
        const response = await AddUpdate(
          "NotificationRule/Insert_NotificationRule",
          postdata
        );

        dispatch(get_Notification_rule(setLoading));
        swal("Good job!", "Successfully Inserted", "success");
        setPostModel(false);
      } catch (err) {
        console.error("Error saving notification:", err);
      }
    }
  };

  useEffect(() => {
    if (!autoManual && ArrObj.length > 0) {
      const labelValue = ArrObj[0]?.value || "";

      SubmitQuerry(ArrObj);
      setname(labelValue);
    }
  }, [ArrObj]);

  const getQueryValues = (name, ope, val) => {
    if (ope === "Equal") {
      return `= ${val}`;
    } else if (ope === "Not Equal") {
      return `<> '${val}'`;
    } else if (ope === "Start With") {
      return `like '${val} %'`;
    } else if (ope === "Ends With") {
      return `like '%${val}'`;
    } else if (ope === "Contain") {
      return `like '%${val}%' `;
    } else if (ope === "In") {
      return `in ('${val}') `;
    } else if (ope === "Is Null") {
      return `${name}is Null`;
    } else if (ope === "Between") {
      return `${name} between ${"100"} and ${val}`;
    }
  };

  const handleDeleteRow = (index) => {
    setArrayObj((prevArr) => prevArr.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    setArrayObj((prevArr) => {
      const newArr = [...prevArr];

      while (newArr.length < 5) {
        newArr.push({
          name: `field_${newArr.length}`,
          label: `Field ${newArr.length + 1}`,
          type: "text",
          value: "",
          operator: "",
        });
      }

      return newArr;
    });
  };

  const handleChanges = (e) => {
    const selectedId = e.target.value;
    setSelectedID(selectedId);

  };


  const handleAddAstrologerClick = (row) => {
    reset();
    setPostModel(true);
  };
  const handleEditClick = async (row) => {
    Reset();
    setId(row.NotificationId);
    setEditValue(row);
   
    dispatch(get_Single_Notification_rule(row.NotificationId, setLoading));
    setPostModel(true)
  };
  const UpdeteClick = async () => {
    let updatedata = {
      NotificationRules: querryText,
      NotificationName: rulename,
      Id: id,
    };
    if (querryText) {
      await AddUpdate("NotificationRule/Update_NotificationRule", updatedata);
      dispatch(get_Notification_rule(setLoading));
      swal("Good job!", "Successfully Inserted", "success");
      setEditModel(false);
    }
  };
  const handleToggleStatusClick = async (row) => {
    let deletedata = {
      Id: row,
    };
    await AddUpdate("NotificationRule/Delete_NotificationRule", deletedata);
    dispatch(get_Notification_rule(setLoading));
    swal("Good job!", "Successfully Deleted", "success");
  };
  const Reset = () => {
    setQuerryText("");
    setname("");
    setRulename("");
    setArrayObj([]);
  };
  const handleDateChange = (e) => {
    let value = e.target.value;

    
    if (value.length === 16) {
      value += ":00"; 
    }

    setDate(value);
  };


  const handleDelete = async (id) => {
      await AddUpdate("NotificationSegments/Delete_Notification", {
        NotificationId: id,
      });
      swal("Deleted!", " Deleted Successfully", "success");
    dispatch(get_Notification_rule(setLoading));
    };

  const columns = [
    {
      name: "Notification Name",
      selector: (row) => row.Title,
      sortable: true,
    },
     {
      name: "Message",
      selector: (row) => row.Message,
      sortable: true,
    },
{
  name: "Scheduled",
  cell: (row) => {
    let label = "Not Scheduled";
    let bgColor = "#6c757d"; 

    if (row.Scheduled === true) {
      label = "Scheduled";
      bgColor = "#ff1a1a"; 
    } else if (row.Scheduled === false) {
      label = "Delivered";
      bgColor = "green";
    }

    return (
      <span
        style={{
          padding: "4px 8px",
          borderRadius: "6px",
          fontWeight: "500",
          color: "white",
          backgroundColor: bgColor,
        }}
      >
        {label}
      </span>
    );
  },
  sortable: true,
}

,
{
  name: "Scheduled Date",
  selector: (row) => {
    if (row.ScheduledDateTime === "1900-01-01T00:00:00" || !row.ScheduledDateTime) {
      return "null";
    }

    const date = new Date(row.ScheduledDateTime);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; 

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    return formattedDate;
  },
  sortable: true,
},

{
  name: "Created Date",
  selector: (row) => {
    if (row.CreatedAt === "1900-01-01T00:00:00" || !row.CreatedAt) {
      return "null";
    }

    const date = new Date(row.CreatedAt);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  },
  sortable: true,
},


 {
      name: "Action",
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item 
            onClick={() => handleEditClick(row)}
            >
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              className="text-danger"
              onClick={() => handleDelete(row.NotificationId)}
            >
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
   
  ];

  const handleImageConversion = (file, setJpg, setPng) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

       
        canvas.toBlob(
          (blob) => {
            setJpg(blob);
            
          },
          "image/jpeg",
          0.9
        );

       
        canvas.toBlob(
          (blob) => {
            setPng(blob);
           
          },
          "image/png"
        );
      };
      img.src = event.target.result;
    };

    reader.readAsDataURL(file);
  };
  

useEffect(() => {
  if (editValue && editValue.length > 0) {
    const data = editValue[0];

    const fixImagePath = (path) => {
      if (!path) return "";
      // Replace backslashes with forward slashes and add protocol if missing
      let cleanPath = path.replace(/\\/g, "/");
      if (!cleanPath.startsWith("http")) {
        cleanPath = "https://" + cleanPath;
      }
      return cleanPath;
    };

    setTitle(data?.Title || "");
    setMessage(data?.Message || "");
    setAudience(data?.Audience || "All");
    setScheduled(data?.Scheduled || false);
    setSelectedID(data?.NotificationId || "");
    setRulename(data?.NotificationName || "");
    setColumnType(data?.ColumnType || "");
    setBeforeSendDays(data?.BeforeSendDays || false);
    setId(data?.NotificationId || "");

  
    setPreviewImage(fixImagePath(data?.UploadImage));
    setLogoImage(fixImagePath(data?.LogoImage));

  
    if (
      data?.ScheduledDateTime &&
      data?.ScheduledDateTime !== "1900-01-01T00:00:00"
    ) {
      const dateObj = new Date(data.ScheduledDateTime);
      const local = new Date(dateObj.getTime() - dateObj.getTimezoneOffset() * 60000);
      setDate(local.toISOString().slice(0, 16));
    } else {
      setDate("");
    }
  }
}, [editValue]);


  return (
    <div>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap main_card">
          <div className="card-action coin-tabs "><h2 style={{ color: '#f7931e', fontWeight: 700, marginBotto: "0px" }}>Send Notification</h2> </div>

          <Link
            onClick={() => handleAddAstrologerClick(null)}
            className="btn btn-primary font-w600  "
          >

            <span style={{ fontSize: "20px" }}>
              <IoNotifications />
            </span>{" "}
            Add Notification
          </Link>
        </div>
        <div className="row mt-4 main_card">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    {loading ? (
                      <Loader />
                    ) : (
                      <div className="table-responsive">
                        <DataTable
                          dense
                          data={Notificationdata}
                          columns={columns}
                          selectableRowsHighlight
                          highlightOnHover
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      </div>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>

      <div>
                
       
     <Modal
      className="modal fade"
      size="xl"
      show={postModel}
      onHide={() => setPostModel(false)}
      backdrop="static"
    >
      <div className="row g-0">
       
        <div className="col-md-6 p-4">
          <div
            className="shadow"
            style={{ borderRadius: "12px", border: "1px solid #e5e7eb" }}
          >
            <div style={{ padding: "1.5rem" }}>
              <h5 className="mb-4 fw-bold" style={{ fontSize: "20px" }}>
                Create Notification
              </h5>

          
              <div className="mb-3">
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Notification Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-3 d-flex align-items-center">
                <div className="form-check form-switch me-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isTopAstrologerSend"
                    checked={isTopAstrologerSend}
                    onChange={async (e) => {
                      const val = e.target.checked;
                      setIsTopAstrologerSend(val);
                      if (val) {
                        await fetchAstrologers();
                      } else {
                        setAstrologers([]);
                        setSelectedAstrologer(null);
                        
                      }
                    }}
                  />
                  <label className="form-check-label" htmlFor="isTopAstrologerSend">
                    Is Top AstrologerSend
                  </label>
                </div>

                {isTopAstrologerSend && (
                  <select
                    className="form-select"
                    style={{ maxWidth: "300px" }}
                    value={selectedAstrologer?.ID || ""}
                    onChange={(e) => {
                      const id = e.target.value;
                      const astro = astrologers.find((a) => String(a.ID) === String(id));
                      setSelectedAstrologer(astro || null);
                      if (astro) {
                        const photo = astro?.PhAvatarUrloto || astro?.AvatarUrl || "";
                        const name = astro?.DisplayName || astro?.DisplayName || astro?.Name || "";
                        const formatted = `Id=${astro.ID},name=${name},url=${photo}`;
                        setMessage(formatted);
                      }
                    }}
                  >
                    <option value="" disabled>
                      Select Astrologer
                    </option>
                    {astrologers?.map((a) => (
                      <option key={a.ID} value={a.ID}>
                        {a.DisplayName || a.AstroName || a.Name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

          
              <div className="mb-3">
                <div className="form-group">
                  <textarea
                    placeholder="Enter your message..."
                    rows="4"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
              </div>

             
              <div className="mb-3">
                <div className="form-group">
                  <label
                    htmlFor="imageUpload1"
                    className="form-label fw-semibold"
                  >
                    Upload Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="imageUpload1"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          setPreviewImage(reader.result);
                        };
                        reader.readAsDataURL(file);
                        handleImageConversion(
                          file,
                          setConvertedJpg1,
                          setConvertedPng1
                        );
                      }
                    }}
                  />
                </div>
              </div>

             
              <div className="mb-3">
                <div className="form-group">
                  <label
                    htmlFor="imageUpload2"
                    className="form-label fw-semibold"
                  >
                    Logo
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="imageUpload2"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          setLogoImage(reader.result);
                        };
                        reader.readAsDataURL(file);
                        handleImageConversion(
                          file,
                          setConvertedJpg2,
                          setConvertedPng2
                        );
                      }
                    }}
                  />
                </div>
              </div>

          
              <div className="mb-3">
                <div className="form-group">
                  <select value={selectedID} onChange={handleChanges}>
                    <option disabled value="">
                      Select Notification Id
                    </option>
                    {drpdatas?.map((item) => (
                      <option key={item.ID} value={item.ID}>
                        {item.NotificationName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="scheduleSwitch"
                  checked={scheduled}
                  onChange={(e) => setScheduled(e.target.checked)}
                />

                <label className="form-check-label" htmlFor="scheduleSwitch">
                  Schedule Notification
                </label>
              </div>

            
              {scheduled && (
                <div className="mb-3">
                  <div className="form-group">
                    <input
                      type="datetime-local"
                      step="1"
                      value={date}
                      onChange={handleDateChange}
                    />
                  </div>
                </div>
              )}

             
              <div className="d-flex justify-content-end mt-2">
             {id?( <button
                  className="btn me-2"
                  style={{
                    backgroundColor: "#ff6f00",
                    color: "#fff",
                    fontWeight: 600,
                    width: "150px",
                  }}
                  onClick={handleUpdate}
                >
                  Update Notification
                </button>): <button
                  className="btn me-2"
                  style={{
                    backgroundColor: "#ff6f00",
                    color: "#fff",
                    fontWeight: 600,
                    width: "150px",
                  }}
                  onClick={handleSubmit}
                >
                  Send Notification
                </button>} 

                <button
                  className="btn"
                  style={{
                    backgroundColor: "red",
                    color: "#fff",
                    fontWeight: 600,
                    width: "150px",
                  }}
                  onClick={() => setPostModel(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

      
        <div
          className="col-md-6 d-flex align-items-center justify-content-center"
          style={{ background: "#f9fafb", borderLeft: "1px solid #ddd" }}
        >
          <div
            style={{
              width: "350px",
              border: "1px solid #ccc",
              borderRadius: "10px",
              padding: "15px",
              background: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
           
            <div className="d-flex justify-content-between align-items-center">
              <div
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {logoImage && (
                  <img
                    src={logoImage}
                    alt="Logo"
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      marginRight: "8px",
                    }}
                  />
                )}
                AstroCall
              </div>
              <span style={{ cursor: "pointer" }}>×</span>
            </div>

          
            <div style={{ fontSize: "14px", marginTop: "8px" }}>
              <strong>{title || "Notification Title"}</strong>
            </div>

           
            <div style={{ fontSize: "13px", color: "#555" }}>
              {message || "Your message will appear here..."}
            </div>

            
            {previewImage && (
              <img
                src={previewImage}
                alt="Preview"
                style={{
                  width: "100%",
                  height: "120px",
                  objectFit: "cover",
                  marginTop: "8px",
                  borderRadius: "6px",
                }}
              />
            )}

        
          </div>
        </div>
      </div>
    </Modal>




     
      </div>
    </div>
  );
};

export default NotificationRuleList;
